<div class="Txt-Withdraw-Coinbase">
  <h2>MuchBetter</h2>
  <span>{{ 'desc_withdraw_muchbetter' | t }}</span>

  <div style="margin-top: 20px">
    <h2>{{ 'Balance' | t }} {{ this._UserHelper.customerUser?.Balance }}</h2>
  </div>

  <div class="withdraw-auto-container">
    <form [formGroup]="coinbaseWithdrawDatas">
      <!--    <mat-form-field style="width:100%">-->
      <!--      <input matInput required placeholder="{{ 'Amount' | t}}" onKeyPress="if(this.value.length==10) return false;" type="number" formControlName="withdrawamount">-->
      <!--    </mat-form-field>-->

      <div class="withdraw-automatic-row">
        <div class="box-first">
          <mat-form-field style="width: 150px; height: 70px" appearance="outline">
            <input matInput required placeholder="{{ 'Amount' | t }}" onKeyPress="if(this.value.length==10) return false;" type="number" formControlName="withdrawamount" />
          </mat-form-field>
        </div>

        <div class="box-second">
          {{ this._UserHelper.customerUser?.Symbol }}
        </div>

        <div class="box-third">
          {{ 'Automatic_Payout_Info' | t }}
        </div>
      </div>

      <div class="withdrawAutoIsChangeWarning" *ngIf="IsChangeActive == false">
        <p>{{ 'Automatic_Payout_Current_limit' | t }} : {{ CurrentLimit }} {{ this._UserHelper.customerUser?.Symbol }}</p>
        <p>{{ 'Automatic_Payout_Info' | t }}</p>
      </div>
    </form>

    <button mat-raised-button class="form-submit-button" (click)="submitCoinbaseWithdrawData()" [disabled]="!coinbaseWithdrawDatas.valid || IsChangeActive == false">
      {{ 'submit' | t }}
    </button>
  </div>
</div>
